import { getAuthDetails } from "./cookiesHelper";

/**
 * Session fields every first-party API call carries. The axios interceptor fills these in as a
 * fallback; call sites that build their own request use these helpers so the request is complete
 * on its own (and so fetch() calls, which the interceptor never sees, get them too).
 */
export const SESSION_FIELD_KEYS = [
  "login_user_type",
  "token_id",
  "login_type",
  "session_id",
  "login_user_email",
  "login_merchant_id",
];

const isMissing = (value) => value === undefined || value === null || value === "";

/** The signed-in session's fields; keys the session does not have are left out. */
export function getSessionFields() {
  const { userTypeData } = getAuthDetails();
  const fields = {};
  for (const key of SESSION_FIELD_KEYS) {
    if (!isMissing(userTypeData?.[key])) fields[key] = userTypeData[key];
  }
  return fields;
}

/** `{ Authorization: "Bearer <token>" }`, or `{}` when there is no session. */
export function getSessionAuthHeader() {
  const token = getAuthDetails()?.userTypeData?.token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * Adds the session fields a body is missing; values the caller set are kept.
 * Plain objects are copied, FormData / URLSearchParams are appended to in place.
 */
export function withSessionFields(body = {}) {
  const fields = getSessionFields();
  if (body instanceof FormData || body instanceof URLSearchParams) {
    for (const [key, value] of Object.entries(fields)) {
      if (!body.has(key)) body.append(key, String(value));
    }
    return body;
  }
  const out = { ...body };
  for (const [key, value] of Object.entries(fields)) {
    if (isMissing(out[key])) out[key] = value;
  }
  return out;
}
